'use strict'

export class Clue {
  constructor ({
    axis = null,
    /**
     * Currently needs an array of Cells.
     *
     * It may be optimized to only contain an array of
     * positional IDs for the clue's Grid Cells.
     */
    cells = [],
    clueNumber = null,
    clueString = '',
    idx = null,
    layout = null,
    metadata = null,
    x = 0,
    y = 0
  }) {
    this.axis = axis
    this.cells = cells
    this.clueNumber = clueNumber
    this.clueString = clueString
    this.idx = idx
    this.layout = layout
    this.metadata = metadata
    this.x = x
    this.y = y

    this._afterInitialize()
  }

  get axis () {
    return this['_axis']
  }

  set axis (value) {
    this['_axis'] = value
  }

  get idx () {
    return this['_idx']
  }

  set idx (value) {
    this['_idx'] = value
  }

  get idxCells () {
    return this['_idxCells']
  }

  set idxCells (value) {
    this['_idxCells'] = value
  }

  get layout () {
    return this['_layout']
  }

  set layout (value) {
    this['_layout'] = value
  }

  get metadata () {
    return this['_metadata']
  }

  set metadata (value) {
    this['_metadata'] = value
  }

  /* Private */
  _afterInitialize () {
    // Only set axis if necessary.
    if (!this.axis && this.cells.length) {
      this._setAxisFromCells()
    }
  }

  _setAxisFromCells () {
    const firstX = this.cells[0].x
    const cells = this.cells.filter(
      (cell) => cell.x !== firstX
    )

    this.axis = cells.length ? 'down' : 'across'
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/pzl-tools/lib/clue.js
// module id = 622
// module chunks = 0